import React from "react"

import { useTranslation } from "react-i18next"

import { Bonus2Type, TypeStats } from "services/bonus/type"

import { formatFiatCurrency } from "util/formatter"

import { getBonusTypeColor } from "../../helpers/bonus2.helpers"

interface Props {
  byType: Record<string, TypeStats>
}

export const BonusTypeCard = ({ byType }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  return (
    <div className="rounded-3xl border p-6 border-[rgba(0,0,0,0.05)] bg-white backdrop-blur-[9px] shadow-[0px_3px_6px_0px_rgba(192,192,192,0.6)] dark:border-[rgba(255,255,255,0.1)] dark:bg-[rgba(255,255,255,0.04)] dark:backdrop-blur-md dark:shadow-none">
      <h4 className="font-semibold mb-4 text-[rgba(6,7,21,1)] dark:text-white">{t("bonus2.analytics.byBonusType")}</h4>
      <div className="space-y-3">
        {Object.entries(byType).map(([type, stats]) => (
          <div key={type} className="flex items-center justify-between rounded-xl p-3 bg-gray-50 dark:bg-[rgba(0,0,0,0.2)]">
            <div className="flex items-center gap-3">
              <span className={`px-2 py-1 text-xs rounded text-white ${getBonusTypeColor(type as Bonus2Type)}`}>{type}</span>
            </div>
            <div className="text-right">
              <div className="font-semibold text-[rgba(6,7,21,1)] dark:text-white">{stats.count} activations</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {stats.completed} completed • {formatFiatCurrency(stats.totalValue)}
              </div>
            </div>
          </div>
        ))}
        {Object.keys(byType).length === 0 && (
          <div className="text-center py-4 text-gray-400 dark:text-gray-500">{t("bonus2.analytics.noDataForSelected")}</div>
        )}
      </div>
    </div>
  )
}
